import { useContext, useEffect } from 'react';
import { Anchor, Box, Heading, Icon, Paragraph } from '@zillow/constellation-10';
import { IconRateUnhappyFilled } from '@zillow/constellation-icons';
import { useIdVerificationCallbacks } from '../../../IdvContext';
import { ExitReason } from '../../../../../models';
import { CUSTOMER_SUPPORT_LINK } from '../../../constants/urls';
import { WizardContext } from '../../../wizard/WizardContext';

export default function ErrorGenericStep() {
  const { setOnNext } = useContext(WizardContext);
  const { onExit } = useIdVerificationCallbacks();

  useEffect(() => {
    setOnNext(() => async () => onExit({ reason: ExitReason.GenericError, success: false }));
    return () => setOnNext(null);
  }, [onExit, setOnNext]);

  return (
    <Box css={{ display: 'flex', flexDirection: 'column', gap: 'default' }}>
      <Icon size="lg" css={{ color: 'icon.subtle' }}>
        <IconRateUnhappyFilled />
      </Icon>
      <Heading level={2} textStyle="heading-sm">
        Something went wrong on our end
      </Heading>
      <Paragraph>
        We are unable to process your request to verify your identity at this time. Contact{' '}
        <Anchor href={CUSTOMER_SUPPORT_LINK} target="_blank" rel="noopener noreferrer">
          customer support
        </Anchor>{' '}
        for help.
      </Paragraph>
    </Box>
  );
}
